import {
  SHOW_SUPPLIER_LOADING,
  GET_SUPPLIER,
  SUPPLIER_ERROR,
  GET_SUPPLIER_DETAILS,
  SHOW_EDIT_SUPPLIER_LOADING,
  DELETE_SUPPLIER,
  CREATE_SUPPLIER,
  EDIT_SUPPLIER,
} from '../actions/types';

/**
 * great-galing-sc-1094: Supplier - Empty employee record can be saved and appears in employee selection dropdown
 */

const initialState = {
  supplierlist: [],
  supplierID: null,
  supplierdetails: null,
  supplierLoading: false,
  editsupplierLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_SUPPLIER_LOADING:
      return {
        ...state,
        supplierLoading: true,
      };
    case SHOW_EDIT_SUPPLIER_LOADING:
      return {
        ...state,
        editsupplierLoading: true,
      };
    case GET_SUPPLIER:
      return {
        ...state,
        supplierlist: payload,
        supplierLoading: false,
      };
    case GET_SUPPLIER_DETAILS:
      return {
        ...state,
        supplierdetails: payload,
        supplierLoading: false,
        editsupplierLoading: false,
      };
    case CREATE_SUPPLIER:
      return {
        ...state,
        supplierlist: [payload, ...state.supplierlist],
        supplierLoading: false,
      };
    case EDIT_SUPPLIER:
      return {
        ...state,
        supplierlist: state.supplierlist.map((supplier) =>
          supplier._id === payload._id
            ? {
                ...supplier,
                supplierName: payload.supplierName,
                email: payload.email,
                phone: payload.phone,
                // Modification start - 26.10.2022 - olain-tarcina-sc-272
                streetAddress: payload.streetAddress,
                category: payload.category,
                // Modification start - 26.10.2022 - olain-tarcina-sc-272
                // Modification start - 26.10.2022 - olain-tarcina-sc-274
                website: payload.website,
                description: payload.description,
                operatingIn: payload.operatingIn,
                postalCode: payload.postalCode,
                city: payload.city,
                country: payload.country,
                // Modification start - 09.17.2026 - great-galing-sc-1094
                employee: payload.employee,
                // Modification end - 09.17.2026 - great-galing-sc-1094
                // Modification start - 26.10.2022 - olain-tarcina-sc-274
              }
            : supplier
        ),
        supplierLoading: false,
      };
    case SUPPLIER_ERROR:
      return {
        ...state,
        error: payload,
        supplierLoading: false,
        editsupplierLoading: false,
      };
    case DELETE_SUPPLIER:
      return {
        ...state,
        supplierlist: state.supplierlist.filter(
          (supplier) => supplier._id !== payload
        ),
        supplierLoading: false,
        editsupplierLoading: false,
      };
    default:
      return state;
  }
}
